import { useSearchEnrollmentCheckerMutation } from '../api/enrollment-checker.api'

const useSearchEnrollmentChecker = () => {
  const [
    searchEnrollmentChecker,
    { data, isLoading, isError, isUninitialized, originalArgs },
  ] = useSearchEnrollmentCheckerMutation()

  return {
    searchEnrollmentChecker,
    data,
    isLoading,
    isError,
    isUninitialized,
    searchTerm: originalArgs,
  }
}

export default useSearchEnrollmentChecker
